import React from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import AddButton from "../../../components/buttons/button";
import { useLocation, useNavigate } from "react-router-dom";
import SearchAddFeild from "../../../components/forms/search-add-field";
import { fetchData } from "../../../components/helper-components/helper-function";
import CloseIcon from "../../../assets/icons/close-icon";
import errorToast from "../../../components/helper-components/error-toast";
import { useDispatch } from "react-redux";
import { goodsTempProImpAction } from "../../../redux/actions/purchase-action";
import { VendorMappingAction } from "../../../redux/actions/settings-action";
import SelectField from "../../../components/forms/select-field";
const GoodsOrderCsv = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state?.data || [];
  const type = location.state?.type || [];
  const prefixName = type === "grn" ? "gort" : "poit";

  const initialValue = {
    ...data,
  };
  const validationSchema = Yup.object().shape({

  });
  // Build the add-vendor-mapping payload from the reviewed rows, grouping every
  // CSV row by its vendor item code so multiple vendor UOMs collapse into one
  // item's mapping list (same shape the vendor-mapping screen sends).
  const buildVendorMappingPayload = (values) => {
    const cm = values?.columnMapping || {};
    const cd = values?.customerDetails || {};
    const grouped = {};

    (values?.itemData || []).forEach((item) => {
      const vendorCode = (item?.[cm.item_code] ?? "").toString().trim();
      const vendorName = (item?.[cm.item_name] ?? "").toString();
      // Vendor UOM as it appears in the vendor's CSV column. When the file has
      // no UOM column (e.g. the pack is embedded in the item name), that cell is
      // blank, so fall back to the backend-translated vendor_uom and finally to
      // the resolved/selected system UOM so the mapping is still captured.
      const vendorUom = (
        item?.[cm.item_uom] ||
        item?.vendor_uom ||
        item?.item_uom ||
        ""
      )
        .toString()
        .trim();
      if (!vendorCode || !item?.item_id) return; // need a resolved system item

      if (!grouped[vendorCode]) {
        grouped[vendorCode] = {
          vendor_item_code: vendorCode,
          vendor_item_name: vendorName,
          system_item_id: item?.item_id || "",
          system_item_code: item?.item_code || "",
          system_item_name: item?.item_name || "",
          mapping: [],
        };
      }

      if (vendorUom && item?.item_uom_id) {
        grouped[vendorCode].mapping.push({
          vendor_uom: vendorUom,
          system_uom: item?.item_uom || "",
          system_uom_id: item?.item_uom_id || "",
          uom_mapping_id: null,
        });
      }
    });

    return {
      vendor_code: cd.cmr_code || "",
      vendor_name: cd.cmr_name || cd.cmr_first_name || cd.cmr_vendor_name || "",
      vendor_id: cd.cmr_id || "",
      data: Object.values(grouped),
    };
  };

  const handleSubmit = (values, actions) => {
    const missingSuggestedItem = values?.itemData?.some(
      (item) => !item.item_id
    );
    const missingBaseUOM = values?.itemData?.some((item) => !item.item_uom_id);
    if (missingSuggestedItem) {
      errorToast("Linked Product Name is required!");
      actions.setSubmitting(false); // Stop the form submission if the validation fails
      return;
    }
    if (missingBaseUOM) {
      errorToast("Base UOM is required!");
      actions.setSubmitting(false); // Stop the form submission if the validation fails
      return;
    }

    dispatch(
      goodsTempProImpAction(
        {
          itemData: values?.itemData?.map((item) => ({
            item_uom: item?.item_uom,
            item_code: item?.item_code,
            item_name: item?.item_name,
            item_hsn: item?.item_hsn,
            item_exp_date: item?.item_exp_date,
            item_sellable_quantity: item?.item_sellable_quantity,
            item_batch_number: item?.item_batch_number,
            item_generic_name: item?.item_generic_name,
            item_free_quantity: item?.item_free_quantity,
            item_batch_free_quantity: item?.item_batch_free_quantity,
            item_tax_percentage: item?.item_tax_percentage,
            item_batch_unit_price: item?.item_batch_unit_price,
            item_batch_purchase_rate: item?.item_batch_purchase_rate,
            item_batch_purhcase_rate_before_tax: item?.item_batch_purhcase_rate_before_tax,
            item_batch_discount_percentage:
              item?.item_batch_discount_percentage,
            item_id: item?.item_id,
            is_item_in_db: item?.is_item_in_db,
            item_uom_id: item?.item_uom_id,
            is_item_uom_in_db: item?.is_item_uom_in_db,
            item_gst: item?.item_gst ?? 0,
            item_cgst_percentage: parseFloat(item?.item_batch_cgst_percentage) ?? 0,
            item_sgst_percentage: parseFloat(item?.item_batch_sgst_percentage) ?? 0,
            item_igst_percentage: parseFloat(item?.item_batch_igst_percentage) ?? 0,
            item_batch_ptr_amount: parseFloat(item?.item_batch_ptr_amount) || 0,
            item_batch_pts_amount: parseFloat(item?.item_batch_pts_amount) || 0,
          })),
        },
        (data) => {
          const itemsData = data?.data?.itemData;

          const raw_total_amount = itemsData.reduce((sum, item) => {
            return sum + (parseFloat(item.item_total_amount) || 0);
          }, 0);

          const total_tax = itemsData.reduce((sum, item) => {
            return sum + (parseFloat(item.item_tax_amount) || 0);
          }, 0);

          const total_discount = itemsData.reduce((sum, item) => {
            return sum + (parseFloat(item.item_discount_amount) || 0);
          }, 0);

          // Subtotal = Total - Tax - Discount
          const sub_total = (
            raw_total_amount -
            total_tax -
            total_discount
          ).toFixed(2);

          const total_amount = Math.round(raw_total_amount).toFixed(2);
          const round_off_value = (
            Math.round(raw_total_amount) - raw_total_amount
          ).toFixed(2);

          // after the GRN import, also persist the vendor -> system item/UOM
          // mappings for these rows via the add-vendor-mapping API
          const vendorMappingPayload = buildVendorMappingPayload(values);
          if (vendorMappingPayload.data.length > 0) {
            dispatch(
              VendorMappingAction(
                vendorMappingPayload,
                () => {},
                (err) =>
                  console.error("Vendor mapping failed after GRN import", err)
              )
            );
          }

          const path =
            type === "grn"
              ? `/goods-receipt/${encodeURIComponent(JSON.stringify([]))}/goods`
              : `/add-purchase-invoice/${encodeURIComponent(
                  JSON.stringify([])
                )}/invoice`;
          navigate(path, {
            state: {
              values: {
                itemData: data?.data?.itemData ?? [],
                ...values?.customerDetails,
                [`${prefixName}_sub_total`]: sub_total,
                [`${prefixName}_total_gst`]: total_tax,
                [`${prefixName}_total_discount`]: total_discount,
                [`${prefixName}_total_amount`]: total_amount,
                [`${prefixName}_round_off_value`]: round_off_value,
                [`${prefixName}_tcs_or_tds_amount`]: 0,
                [`${prefixName}_tcs_or_tds_percentage_id`]: "",
                [`${prefixName}_tcs_or_tds_percentage`]: 0,
                [`${prefixName}_tds_tcs_type`]: "",
              },
            },
          });
        },
        onErrorImport
      )
    );
  };

  const onErrorImport = (data) => {
    errorToast(data?.data?.message);
  };

  return (
    <InnerLayout
      backBtn={true}
      title={`${
        prefixName === "gort"
          ? "Goods Receipt CSV Import"
          : "Purchase Invoice Import"
      }    `}
    >
      <Formik
        enableReinitialize={true}
        initialValues={initialValue}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, setFieldValue, errors }) => {
          console.log(values, "dsfsfdsfdsfdsfdsf");
          return (
            <Form className="h-full">
              <div
                className="flex gap-3 justify-between  overflow-auto"
                style={{
                  maxHeight: `calc(100% - 4.5rem)`,
                  height: `calc(100% - 4.5rem)`,
                }}
              >
                <div className="min-w-[100%] border-EAECF0 border mb-2 h-fit     scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200">
                  <table className="my-tab">
                    <thead className="sticky top-0 z-10">
                      <tr className="bg-F2F4F5">
                        {tableHeading.map((heading, index) => (
                          <th
                            key={index}
                            className={`${"border-b-EAECF0 border-b h-[3rem] text-left px-2"} whitespace-nowrap text-sm fw_700 text-475467 bg-F2F4F5
                           `}
                          >
                            {heading?.toUpperCase()}
                          </th>
                        ))}
                      </tr>
                    </thead>

                    <tbody>
                      {values?.itemData?.map((item, index) => (
                        <tr
                        // className={`${
                        //   item?.is_item_in_db ? "" : "bg-F51D00"
                        // }`}
                        >
                          <td className="text-sm h-[3.5rem] px-3 border-b-EAECF0 border-b  fw_400 text-secondary ">
                            {index + 1}
                          </td>
                          <td className="text-sm h-[3.5rem] px-3 border-b-EAECF0 border-b  fw_400 text-secondary text-nowrap">
                            {item?.[values?.columnMapping?.item_code] || "N/A"}
                          </td>
                          <td className="text-sm h-[3.5rem] px-3 text-center border-b-EAECF0 border-b  fw_400 text-secondary ">
                            {item?.[values?.columnMapping?.item_name] || "N/A"}
                          </td>
                          <td className="text-sm h-[3.5rem] px-3 border-b-EAECF0 border-b  fw_400 text-secondary ">
                            {item?.[values?.columnMapping?.item_uom] || "N/A"}
                          </td>
                          <td className="text-sm h-[3.5rem] px-3 border-b-EAECF0 border-b  fw_400 text-secondary ">
                            {item?.item_code || "N/A"}
                          </td>
                          <td
                            className={`text-sm h-[3.5rem] min-w-[20rem] border-b-EAECF0 border-b    fw_400 text-secondary `}
                          >
                            <div
                              className={`relative w-full ${
                                item?.is_item_in_db || item?.item_id
                                  ? ""
                                  : "border-F51D00 border-2  rounded-md"
                              } `}
                            >
                              <SearchAddFeild
                                errorClass="hidden"
                                isRequired={false}
                                value={{
                                  label: item?.item_name,
                                  value: "",
                                }}
                                name={`itemData[${index}].item_id`}
                                field={`item_name`}
                                isLabelReq={false}
                                defaultSelectClass=""
                                placeholder=""
                                fetchData={fetchData}
                                onChange={async (selectedOption) => {
                                  if(selectedOption?.text==="new_item"){
                                    navigate("/add-product");
                                    return;
                                  }
                                  const updatedData = [...values.itemData];
                                  const updatedItem = updatedData[index];
                                  updatedData[index] = {
                                    ...updatedItem,
                                    item_name: selectedOption.item_name,
                                    item_id: selectedOption.item_id,
                                    item_code: selectedOption.item_code,
                                    is_item_in_db: true,
                                    item_uom_id:
                                      selectedOption.item_pur_purchasing_uom_name_id,
                                    item_uom:
                                      selectedOption.item_pur_purchasing_uom_name,
                                    // uom_dropdown: selectedOption.uom_dropdown,
                                  };
                                  // dispatch(
                                  //   producDetailsAction(
                                  //     {
                                  //       item_id: updatedData?.[index]?.item_id,
                                  //       item_uom: updatedData?.[index]
                                  //         ?.is_item_uom_in_db
                                  //         ? updatedData?.[index]?.item_uom_id
                                  //         : "",
                                  //     },
                                  //     (data) => {
                                  //       onSuccessDetails(
                                  //         data,
                                  //         updatedData?.[index],
                                  //         setFieldValue
                                  //       );
                                  //     },
                                  //     onErrorDetails
                                  //   )
                                  // );
                                  setFieldValue("itemData", updatedData);
                                }}
                                index={index}
                                defaultInputValue={true}
                              />

                              <div
                                onClick={() => {
                                  setFieldValue(
                                    `itemData[${index}].item_id`,
                                    ""
                                  );
                                  setFieldValue(
                                    `itemData[${index}].item_name`,
                                    ""
                                  );

                                  // setFieldValue(
                                  //   `itemData[${index}].item_uom_id`,
                                  //   ""
                                  // );
                                  // setFieldValue(
                                  //   `itemData[${index}].item_uom`,
                                  //   ""
                                  // );
                                  // setFieldValue(
                                  //   `itemData[${index}].uom_dropdown`,
                                  //   []
                                  // );
                                }}
                                className="absolute cursor-pointer z-15 right-1 top-1/2 transform -translate-y-1/2"
                              >
                                {item?.item_name && (
                                  <CloseIcon width={15} height={15} />
                                )}
                              </div>
                            </div>
                          </td>
                          <td className="text-sm h-[3.5rem] px-3 border-b-EAECF0 border-b  fw_400 text-secondary ">
                            {item?.item_batch_number || "N/A"}
                          </td>

                          <td
                            className={`text-sm h-[3.5rem] min-w-[9rem] px-3  fw_400 text-secondary rounded-md border-b-EAECF0 border-b   `}
                          >
                            {/* <span
                              className={`${
                                item?.is_item_uom_in_db
                                  ? ""
                                  : "border-F51D00 border-2  rounded-md py-[11px] px-4"
                              }`}
                            >
                              {" "}
                              {item?.item_uom || "N/A"}
                            </span> */}
                            <div
                              className={`${
                                item?.is_item_uom_in_db
                                  ? ""
                                  : "border-F51D00 border-2  rounded-md  px-4"
                              }`}
                            >
                              <SelectField
                                handleSelected={(sel) => {
                                  setFieldValue(
                                    `itemData[${index}].item_uom`,
                                    sel?.label
                                  );
                                  setFieldValue(
                                    `itemData[${index}].is_item_uom_in_db`,
                                    true
                                  );
                                }}
                                borderclass={
                                  item?.item_uom ? "" : "border border-F51D00"
                                }
                                defaultSelectClass={
                                  item?.item_uom
                                    ? "border-0"
                                    : "border border-F51D00 rounded-md"
                                }
                                selectClass="w-full"
                                defaultValue={
                                  item?.item_uom
                                    ? {
                                        label: item?.item_uom ?? "",
                                      }
                                    : null
                                }
                                errMsgContainerClass="hidden"
                                id={`itemData[${index}].item_uom_id`}
                                isContainer={false}
                                options={(() => {
                                  const opts =
                                    item?.uom_dropdown?.map((opt) => ({
                                      label: opt?.alt_uom,
                                      value: opt?.item_id,
                                    })) || [];
                                  // The resolved item_uom_id may belong to a
                                  // different UOM group than this item's
                                  // uom_dropdown, so it won't be in the options
                                  // and the select would show the raw id. Make
                                  // sure the current selection is always present
                                  // (labelled with its UOM name).
                                  if (
                                    item?.item_uom_id &&
                                    !opts.some(
                                      (opt) => opt.value === item?.item_uom_id
                                    )
                                  ) {
                                    opts.unshift({
                                      label: item?.item_uom,
                                      value: item?.item_uom_id,
                                    });
                                  }
                                  return opts;
                                })()}
                                name={`itemData[${index}].item_uom_id`}
                                placeholder={"Select UOM"}
                              />
                            </div>
                          </td>
                          <td className="text-sm h-[3.5rem] px-3 border-b-EAECF0 border-b  fw_400 text-secondary ">
                            {item?.item_batch_purchase_rate || "N/A"}
                          </td>
                          <td className="text-sm h-[3.5rem] px-3 border-b-EAECF0 border-b  fw_400 text-secondary ">
                            {item?.item_gst ||
                              parseFloat(item?.item_cgst_percentage) +
                                parseFloat(item?.item_sgst_percentage)}
                          </td>

                          <td className="text-sm h-[3.5rem] px-3 border-b-EAECF0 border-b  fw_400 text-secondary ">
                            {item?.item_sellable_quantity || "N/A"}
                          </td>
                          <td className="text-sm h-[3.5rem] px-3 border-b-EAECF0 border-b  fw_400 text-secondary ">
                            {item?.item_batch_free_quantity || "N/A"}
                          </td>
                          <td className="text-sm h-[3.5rem] px-3 border-b-EAECF0 border-b  fw_400 text-secondary ">
                            {item?.item_batch_unit_price || "N/A"}
                          </td>
                          <td className="text-sm h-[3.5rem] px-3 border-b-EAECF0 border-b  fw_400 text-secondary ">
                            {item?.item_exp_date || "N/A"}
                          </td>
                          <td className="text-sm h-[3.5rem] px-3 border-b-EAECF0 border-b  fw_400 text-secondary ">
                            {item?.item_batch_discount_percentage || "N/A"}
                          </td>
                          {/* <td className="text-sm h-[3rem] px-3 border-b-EAECF0 border-b  fw_400 text-secondary ">
                            {item?.item_batch_discount_amount || "N/A"}
                          </td> */}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="flex justify-between invoice-bottom-container w-full py-4 px-4 items-center h-[4rem] ">
                <div className="flex gap-3 fw_600"></div>
                <AddButton prefixIcon={false} text="Import" type="submit" />
              </div>
            </Form>
          );
        }}
      </Formik>
    </InnerLayout>
  );
};

export default GoodsOrderCsv;
const tableHeading = [
  "SL No",
  "Prod. Code",
  "Prod. Name",
  "Supp. Prod. Pack",
  "Linked Prod. Code",
  "Linked Product Name",
  "Batch Number",
  "Packing",
  "Pur. Price",
  "GST %",
  "Qty",
  "Free",
  "MRP",
  "Expiry",
  "Pur Sch Disc %",
  // "Pur Sch Disc Amt.",
  // "Bulk Pur Sch Disc Amt.",
];
